export const dofHeading = 'These Details Are on File';
export const dofHeadingAlt = 'These Details Are on File';
export const dofShowDetails = 'Show Details';
export const dofHideDetails = 'Hide Details';
export const dofLink = 'Link';
export const moduleId = 'InformationSectionUpdate';
